import React, { useEffect, useState } from 'react'
import { BiometricCard, WbaCatgoryCard, WbaReportCard } from '../styles';
import { ImageUrl } from '../../../utils/constants';
import PropTypes from 'prop-types';
import { fetchApi, yearOptions } from '../../../utils/methods';
import { GetBiometricReportHistory, GetWBAReportHistory } from '../../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { CommonFilterDropdown } from '../../common/CommonYearFilter/CommonYearFilter';
import { InfoIconBranding } from '../../../utils/icons';

const History = ({getTotalWellbeingPercentage, user}) => {

  const[wellnessAssessment,setWellnessAssessment] = useState(null);
  const[userBiometric, setUserBiometric] = useState(null);
  const[selectedYear, setSelectedYear]= useState(new Date().getFullYear());
  const[selectedBiometricYear, setSelectedBiometricYear] = useState(new Date().getFullYear());

  useEffect(()=>{
    fetchWbaReportHistory(2025);
    fetchBiometricReportHistory(2025);
  },[]);

  const fetchWbaReportHistory = async(year)=>{
    const res = await fetchApi(`${GetWBAReportHistory}/${user.uid}/${year}`,"GET");

    if(res?.data?.message){
      toast.error(res?.data?.message);
    }else{
      setWellnessAssessment(res.data);
    //   setLoading(false);
    }
  }

  const fetchBiometricReportHistory = async(year)=>{
    
    const res = await fetchApi(`${GetBiometricReportHistory}/${user.uid}/${year}`,"GET");
    if(res?.data?.message){
      toast.error(res?.data?.message);
    }else{
      setUserBiometric(res.data);
    //   setLoading(false);
    }
  }

  const selectYearData = (value) => {
    setSelectedYear(value)
    fetchWbaReportHistory(value)
  }

  const selectBiometricYearData = (value) => {
    setSelectedBiometricYear(value)
    fetchBiometricReportHistory(value)
  }

  const getWbaReport = () => {
    const wellbeingAssesmentData = [
      {
        title: 'Lifestyle',
        fill1: wellnessAssessment?.lifestyle ? (wellnessAssessment.lifestyle) : 0,
        fillColor1: 'rgb(157, 135, 169)',
        backgroundFill1: 'rgba(157, 135, 169, 0.15)',
        imgUrl: '/profile-page/lifestyle.svg',
        width: '13px',
        color: "#B1AA56",
        label: wellnessAssessment?.lifestyle ? wellnessAssessment.lifestyle : 0,
      },
      {
        title: 'Fitness',
        fill1: wellnessAssessment?.fitness ? (wellnessAssessment.fitness) : 0,
        fillColor1: 'rgb(105, 194, 255)',
        backgroundFill1: 'rgba(105, 194, 255, 0.15)',
        imgUrl: '/profile-page/fitness.svg',
        width: '20px',
        color: "#DA9B6C",
        label: wellnessAssessment?.fitness ? wellnessAssessment.fitness : 0
      },
      {
        title: 'Nutrition',
        fill1: wellnessAssessment?.nutrition ? (wellnessAssessment.nutrition) : 0,
        fillColor1: 'rgb(159, 201, 137)',
        backgroundFill1: 'rgba(159, 201, 137, 0.15)',
        imgUrl: '/profile-page/nutrition.svg',
        width: '13px',
        color: "#75B084",
        label: wellnessAssessment?.nutrition ? wellnessAssessment.nutrition : 0
      },
      {
        title: 'Mental Health',
        fill1: wellnessAssessment?.stress ? (wellnessAssessment.stress) : 0,
        fillColor1: 'rgb(255, 153, 134)',
        backgroundFill1: 'rgba(255, 153, 134, 0.15)',
        imgUrl: '/profile-page/mental.svg',
        width: '13px',
        color: "#BE7D9C",
        label: wellnessAssessment?.stress ? wellnessAssessment.stress : 0
      },
      {
        title: 'Workplace',
        fill1: wellnessAssessment?.workplace ? (wellnessAssessment.workplace) : 0,
        fillColor1: 'rgb(246, 180, 121)',
        backgroundFill1: 'rgba(246, 180, 121, 0.15)',
        imgUrl: '/profile-page/workplace.svg',
        width: '21px',
        color: "#92A4DA",
        label: wellnessAssessment?.workplace ? wellnessAssessment.workplace : 0
      }
    ];
    const totalCount=wellbeingAssesmentData[0]?.fill1+wellbeingAssesmentData[1]?.fill1+wellbeingAssesmentData[2]?.fill1+wellbeingAssesmentData[3]?.fill1+wellbeingAssesmentData[4]?.fill1;
    const totalPercentage=getTotalWellbeingPercentage(totalCount)
    return (
      <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>My WBA Reports</div>
            <div className='line'/>
            <div className='total'>Total Score: {totalCount}/200 | {totalPercentage}</div>
          </div>
          <div className='end'>
            <CommonFilterDropdown
              options={yearOptions(user.created_at)}
              selectedOption={selectedYear}
              setSelectedOption={selectYearData}
              dropdownHeight={"auto"}
            />
            {/* <div className='icon' onClick={() => this.hideShowCompareYear()}><ProfileCompare/></div> */}
            {/* <div className='icon' >{RecognitionEyeIcon("#F37A65")}</div>
            <div className='view-report'>View Full Report</div> */}
          </div>
        </div>
        <div className='border'/>
        <div className='category-wrapper'>
          {wellbeingAssesmentData.map((item, index) => {
            const circumference = 2 * Math.PI * 50; // Adjust radius if needed
            const offset = circumference - (item?.fill1 / 40) * circumference; // 40% of total

            return (
              <WbaCatgoryCard key={index}>
                <div className='category'>
                  <img src={ImageUrl + item?.imgUrl} alt={item.title} />
                </div>
                <div className='category-name'>{item.title}</div>

                {/* Circular Progress Bar */}
                <div className="progress-container">
                  <svg width="120" height="120" viewBox="0 0 120 120">
                    {/* Background Circle */}
                    <circle cx="60" cy="60" r="50" stroke="#ddd" strokeWidth="6" fill="none" />

                    {/* Progress Circle */}
                    <circle
                      className="progress-ring"
                      cx="60"
                      cy="60"
                      r="50"
                      stroke={item.color}
                      strokeWidth="6"
                      fill="none"
                      strokeLinecap="round"
                      strokeDasharray={circumference}
                      strokeDashoffset={offset} // Directly use offset
                      style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                    />
                  </svg>

                  {/* Dynamic Percentage Text */}
                  <span className="progress-text">{item.fill1}/40</span>
                </div>
              </WbaCatgoryCard>
            );
          })}

        </div>
      </WbaReportCard>
    )
  };

  const getBiometricReport = () => {
    // const {userBiometric}=this.props;
    // const {biometricDetails} = this.state
    const biometricData = [
      {
        title: 'Weight',
        value: userBiometric?.[0]?.weight ? userBiometric?.[0]?.weight+ " lb" : "NA",
        color: "#91C49D",
      },
      {
        title: 'Height',
        value: userBiometric?.[0]?.height ? userBiometric?.[0]?.height : "NA",
        color: "#91C49D",
      },
      {
        title: 'Waist',
        value: userBiometric?.[0]?.waistCircumference ? userBiometric?.[0]?.waistCircumference+" in" : "NA",
        color: "#91C49D",
      },
      {
        title: 'BMI',
        value: userBiometric?.[0]?.bmi ? userBiometric?.[0]?.bmi : "NA",
        color: "#91C49D",
      },
      {
        title: 'Systolic Blood Pressure',
        value: userBiometric?.[0]?.bloodPressureSys ? userBiometric?.[0]?.bloodPressureSys +" mm/Hg" : "NA",
        color: "#DA6C74",
      },
      {
        title: 'HDL Cholesterol',
        value: userBiometric?.[0]?.cholestrolHdl ? userBiometric?.[0]?.cholestrolHdl+ " mg/dl" : "NA",
        color: "#DA6C74",
      },
      {
        title: 'LDL Cholesterol',
        value:  userBiometric?.[0]?.cholestrolLdl ? userBiometric?.[0]?.cholestrolLdl +" mg/dl" : "NA",
        color: "#B1AA56",
      },
      {
        title: 'Triglycerides',
        value: userBiometric?.[0]?.triglycerides ? userBiometric?.[0]?.triglycerides+ " mg/dl" : "NA",
        color: "#91C49D",
      },
      {
        title: 'Glucose',
        value: userBiometric?.[0]?.glucose ? userBiometric?.[0]?.glucose+ " mg/dl" : "NA",
        color: "#91C49D",
      },
      {
        title: 'Diastolic Blood Pressure',
        value: userBiometric?.[0]?.bloodPressureDia ? userBiometric?.[0]?.bloodPressureDia+ " mm/Hg" : "NA",
        color: "#B1AA56",
      }  
    ];
    // const completedDate=dayjs(new Date(biometricDetails?.biometric_details?.physicianFormTimestamp)).format("MMMM DD"); // Format the date as "15, Jan"
    return(
      <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>My Biometric Screening Report</div>
            <div className='icon'>{InfoIconBranding()}</div>
          </div>
          <div className='end'>
            <CommonFilterDropdown
              options={yearOptions(user.created_at)}
              selectedOption={selectedBiometricYear}
              setSelectedOption={selectBiometricYearData}
              dropdownHeight={"auto"}
            />
          </div>
        </div>
        <div className='border'/>
        <div className='category-wrapper' style={{flexWrap:"wrap"}}>
          {biometricData?.map((data,index)=>(
            <BiometricCard key={index} color={data.color}>
              <div className='circle'/>
              <div className='wrap'>
                <div className='field'>{data?.title}</div>
                <div className='value'>{data?.value}</div>
              </div>
            </BiometricCard>))}
        </div>
        <div className='border'/>
        {/* <div className='biometric-complete'>Biometric screening was completed on {completedDate}.</div> */}
      </WbaReportCard>
    )
  }
  return (
    <>
      {getWbaReport()}
      {getBiometricReport()}
    </>
  )
}

History.propTypes = {
  getTotalWellbeingPercentage: PropTypes.func,
  wellnessAssessment:PropTypes.object,
  user:PropTypes.object
}

export default History